import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function AirportIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M1 20.9999H23V22.9999H1V20.9999Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16921 4.68395C5.03321 4.27595 4.65121 3.99995 4.22021 3.99995H1.00021V10.3419C1.00021 11.8399 1.77308 12.4777 3.22008 12.8407L17.2202 16.1439L19.8888 16.7378C21.3217 16.7703 22.5958 15.7973 22.9184 14.425C23.2313 13.0946 22.5721 11.6741 21.3148 10.9712L15.8671 9.79136L13.1812 1.7261C13.0592 1.2961 12.6662 1.0001 12.2202 1.0001L8.22021 1L9.22021 8.1341L6.11834 7.36071L5.16921 4.68395ZM10.5201 3.00006L11.6123 10.7917L4.59229 9.04145L3.51383 5.99995H3.00021V10.3419C3.00021 10.5181 3.01991 10.6113 3.03032 10.6482C3.07946 10.683 3.25016 10.7852 3.69409 10.8976L17.6671 14.1944L20.0807 14.7316C20.5245 14.6805 20.8802 14.3557 20.9715 13.9673C21.0529 13.6214 20.9203 13.1602 20.534 12.8484L14.3297 11.5048L11.4975 3.00008L10.5201 3.00006ZM1 20.9999V22.9999H23V20.9999H1Z",
    fill: "currentColor"
  }));
}